/* 🤖 this file was generated by svg-to-ts*/
export const icoNotification: {
  name: 'notification';
  data: string;
} = {
  name: 'notification',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.002 2a1 1 0 011 1v1l-.004.085c3.144.553 4.922 3.74 5.001 7.636l.003.279c-.002 3 .598 4.767 1.805 6.407A1 1 0 0119.002 20h-5c0 1-1 2-2 2s-2-1-2-2h-5a1 1 0 01-.815-1.58c1.162-1.63 1.761-3.27 1.811-6.036L6.002 12c0-3.996 1.8-7.342 5.004-7.914L11.002 4V3a1 1 0 011-1zm-.01 4C9.533 6 8 8.57 8 12c0 2.044-.53 4.402-1.344 6h10.792c-.803-1.568-1.446-3.972-1.446-6 0-3.453-1.513-6-4.01-6z" fill="#909090"/></svg>`
};
